'use strict';

import angular from 'angular';

export default angular
  .module('app.btnDefault', [])
  .directive('btnDefault', btnDirective => {
    'ngInject';

    return Object.assign({}, btnDirective[0], {
      template: `
        <button class="btn" type="button" theme="default" ng-class="btnClasses" ng-transclude></button>
      `
    });
  }).name;
